import React, { useState, useEffect } from "react";
import Classes from "./Header.css";
import { Nav, Navbar } from "react-bootstrap";
import { isMobileOrTablet } from "../Utils";
import axios from "axios";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import RigVedQuotes from "../RigvedQuotes";

const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
  const [quotes, setQuotesData] = useState([]);
  let prevScrollPos = window.scrollY;

  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");

    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        // Perform your desired actions for scrolling up here
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        // Perform your desired actions for scrolling down here
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
          setShowRigVedQuotes(false);
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };
  // useEffect(() => {
  //   const fetchQuotesJSON = async () => {
  //     try {
  //       const timestamp = Date.now();
  //       const url = `${process.env.REACT_APP_QUOTES_JSON}?timestamp=${timestamp}`;
  //       const response = await axios.get(url);
  //       const quotesArray = response.data.quotes;
  //       setQuotesData(quotesArray);
  //     } catch (error) {
  //       console.log("Unable to load quotes: ", error);
  //     }
  //   };
  //   fetchQuotesJSON();
  // }, []);

  return (
    <>
      <div>
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Navbar.Brand className="ps-3">
            <div className="d-flex">
              <div>
                <a
                  href="https://www.swmc.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Sun West Mortgage Logo"
                >
                  <img
                    src={`${process.env.REACT_APP_CDN_LINK}swmc-images/sunwest-trust-white-logo.png`}
                    className="main_logo img-fluid"
                    alt="Sun West Logo"
                  />
                </a>
              </div>

            </div>


          </Navbar.Brand>
          <Nav className={Classes.nav_temp}>
            {/* <div className="seperator"></div> */}
            <a
              href="https://www.angelai.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.REACT_APP_CDN}carolinasConnect/postevent/angelai-logo.webp`}
                className="angelai-university"
                alt="AngelAi Logo"
              ></img>
            </a>
          </Nav>

          <div className="brandTagLineContainerDesktop">
            <p
              variant="primary"
              className="brandTagLine"
              onClick={() => {
                setShowRigVedQuotes(true);
              }}
              onMouseOver={() => {
                setShowRigVedQuotes(true);
              }}
              onMouseOut={() => {
                setShowRigVedQuotes(false);
              }}
            // aria-label="Brand Tag Line"
            >
              Nothing Is Beyond Reach
            </p>
            <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
          </div>

          <div className="mobile-AccessibilityMenu-show1">
            <UserWayAccessibilityMenu color="white" width={30} height={30} />
          </div>
            <div className="desktop-AccessibilityMenu-show">
              <UserWayAccessibilityMenu color="white" width={40} height={40} />
            </div>

        </Navbar>

      </div>
    </>
  );
};

export default HeaderNavbar;
